import { PropTypes } from 'prop-types'

export const areaDefinitionPropType = PropTypes.shape({
    position: PropTypes.shape({
        latitude: PropTypes.number,
        longitude: PropTypes.number
    }),
    positionNodes: PropTypes.arrayOf(
        PropTypes.shape({
            latitude: PropTypes.number,
            longitude: PropTypes.number
        })
    ),
    radius: PropTypes.number,
    type: PropTypes.string,
    width: PropTypes.number
})
